import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledHoverIcon = styled.span`
  position: relative;
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  display: inline-block;

  > * {
    position: absolute;
    top: 0;
    left: 0;
    width: 30px;
  }

  &:hover {
    > :first-child {
      z-index: 1;
    }
  }
`;

const HoverIcon = ({ src, hoverSrc, alt, size }) => {
  return (
    <StyledHoverIcon size={size}>
      <img src={hoverSrc} alt={alt} />
      <img src={src} alt={alt} />
    </StyledHoverIcon>
  );
};

HoverIcon.propTypes = {
  src: PropTypes.string.isRequired,
  hoverSrc: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  size: PropTypes.string
};

HoverIcon.defaultProps = {
  size: '30px'
};

export default HoverIcon;
